import { Card, CardContent, CardHeader, CardTitle, Pagination, SearchBar } from '@shared/components';
import type { FundAccountsModel } from '../../../hooks/useFundAccountsSection';
import {
    fundAccountsHeading,
    NO_FUND_ACCOUNT_MATCHES_MESSAGE,
    NO_FUND_ACCOUNTS_MESSAGE,
} from '../../../utils/fundStatementLabels';
import { FundAccountsDataTable } from './FundAccountsDataTable';

export function FundAccountList({ list, currency, selectedKey, onSelect }: FundAccountsModel) {
    const emptyMessage = list.total === 0 ? NO_FUND_ACCOUNTS_MESSAGE : NO_FUND_ACCOUNT_MATCHES_MESSAGE;
    return (
        <Card ariaLabelledBy="fund-accounts-heading">
            <CardHeader>
                <CardTitle id="fund-accounts-heading">{fundAccountsHeading(list.total)}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-3">
                    {list.total > 0 && (
                        <SearchBar
                            searchTerm={list.searchTerm}
                            setSearchTerm={list.onSearch}
                            placeholder="Search by dealer code, product or Sage code"
                            className="xl:w-full"
                        />
                    )}
                    <FundAccountsDataTable
                        rows={list.rows}
                        selectedKey={selectedKey}
                        currency={currency}
                        emptyMessage={emptyMessage}
                        onSelect={onSelect}
                    />
                    {list.lastPage > 1 && (
                        <Pagination
                            currentPage={list.page}
                            lastPage={list.lastPage}
                            total={list.matchCount}
                            perPage={list.perPage}
                            from={list.from}
                            to={list.to}
                            onPageChange={list.onPageChange}
                        />
                    )}
                </div>
            </CardContent>
        </Card>
    );
}
